module.exports = __webpack_public_path__ + "img/40_37_014_310.fecc4f0d.jpg";